import Review from './components/Review';
import './App.css';

function App() {
  return (
    <main>
      <div className="container">
        
        <Review />
      </div>
    </main>
  );
}

export default App;
